<template>
  <div
    class="IngredientContainer"
    :style="{
      width: cssProp(716),
      height: cssProp(625),
      pointerEvents: 'none',
      position: 'relative'
    }"
  >
    <div v-if="productIwcImg && productIwcImgPos">
      <img
        class="IngredientWizardCompositionImage"
        :src="productIwcImg"
        :style="{
          top: cssProp(productIwcImgPos.top, '0'),
          left: cssProp(productIwcImgPos.left - 180, '0'),
          width: cssProp(productIwcImgPos.width, 'auto'),
          height: cssProp(productIwcImgPos.height, 'auto'),
          zIndex: productIwcImgPos['z_index']
        }"
      />
    </div>

    <div v-for="imageGroup in compositionImageGroups" :key="imageGroup.groupId">
      <div v-for="imageItem in imageGroup.items" :key="imageItem.item_key">
        <img
          v-if="imageItem.position"
          :src="imageItem.composition_image"
          class="Ingredient"
          :style="{
            top: cssProp(imageItem.position.top, '0'),
            left: cssProp(imageItem.position.left - 180, '0'),
            width: cssProp(imageItem.position.width, 'auto'),
            height: cssProp(imageItem.position.height, 'auto'),
            zIndex: imageItem.position['z_index']
          }"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IngredientImageComposition",
  props: {
    product: {
      type: Object
    },
    compositionImageGroups: {
      type: Array,
      default: () => []
    },
    scale: {
      type: Number,
      default: 1.0
    },
  },
  data() {
    return {
      productIwcImg: this.product.ingredient_wizard_composition_image,
      productIwcImgPos: this.product
        .ingredient_wizard_composition_image_position
    };
  },
  created() {},
  methods: {
    cssProp(value, default_value) {
      if (Number.isInteger(value)) return Math.round(value * this.scale) + "px";
      return default_value;
    }
  }
};
</script>

<style scoped lang="scss">
.IngredientContainer {
  left: 0;
  top: 0;
  position: absolute;
  z-index: 100;

  & > div {
    width: 716px;
    height: 625px;
    transform-origin: top left;
  }
}

.Ingredient {
  position: absolute;
}

.IngredientWizardCompositionImage {
  position: absolute;
}
</style>
